import http from 'axios'

export const getBillingAccounts = () => ({
  type: 'BILLING/GET_BILLING_ACCOUNTS',
  payload: http({
    method: 'GET',
    url: 'api/v1/billingAccounts',
  }),
})

export const getBillingAccount = ban => ({
  type: 'BILLING/GET_BILLING_ACCOUNT',
  payload: http({
    method: 'GET',
    url: `api/v1/billingAccounts/${ban}`,
  }),
})

export const getPaymentTerms = () => ({
  type: 'BILLING/GET_PAYMENT_TERMS',
  payload: http({
    method: 'GET',
    url: 'api/v1/billingAccounts/paymentTerms',
  }),
})

export const getPayments = () => ({
  type: 'BILLING/GET_PAYMENTS',
  payload: http({
    method: 'GET',
    url: 'api/v1/payments',
    params: {
      limit: '1000',
    },
  }),
})

export const getBillAttachments = () => ({
  type: 'BILLING/GET_BILL_ATTACHMENTS',
  payload: http({
    method: 'GET',
    url: 'api/v1/billingAccounts/billAttachments',
  }),
})

export const createBillingAccount = formData => (dispatch, getState) =>
  dispatch({
    type: 'BILLING/CREATE_BILLING_ACCOUNT',
    payload: http({
      method: 'POST',
      url: 'api/v1/billingAccounts',
      data: {
        ...formData,
        paymentTerms: '28 Days',
        customerId: getState().auth.user.id,
        billAttachments: ['Detailed Spend', 'Inbound Report'],
      },
    }),
  })

export const updateBillingAccount = formData => ({
  type: 'BILLING/UPDATE_BILLING_ACCOUNT',
  payload: http({
    method: 'PUT',
    url: `api/v1/billingAccounts/${formData.ban}`,
    data: formData,
  }),
})

// deprecated, use updateCreditCard() instead
export const addCreditCard = ({ ban, number, expiryYear, expiryMonth, cvc }) => dispatch =>
  dispatch({
    type: 'BILLING/ADD_CREDIT_CARD',
    payload: http({
      method: 'POST',
      url: `api/v1/billingAccounts/${ban}/creditCards`,
      data: { number, expiryYear, expiryMonth, cvc },
    }),
  })

export const getBills = ({ offset, limit, filterStatus } = {}) => ({
  type: 'BILLING/GET_BILLS',
  payload: http({
    method: 'GET',
    url: 'api/v1/bills',
    params: { offset, limit, 'filter[status]': filterStatus },
  }),
})

export const payBill = ({ billId, ban, creditCard, useAsDefault, paymentMethodId }) => ({
  type: 'BILLING/PAY_BILL',
  payload: http({
    method: 'POST',
    url: `api/v1/bills/${billId}/pay`,
    data: { ban, creditCard, useAsDefault, paymentMethodId },
  }),
})

// request client secret from Stripe via setup intent
export const setupBankAccount = ({ ban }) => ({
  type: 'BILLING/SETUP_BANK_ACCOUNT',
  payload: http({
    method: 'POST',
    url: `api/v1/billingAccounts/${ban}/bankAccount`,
  }),
})

// After finishing setup intent on Stripe we have to
// update BSB and Bank Account's last 4 digits in CRM
export const updateBankAccount = ({ ban, paymentMethodId }) => ({
  type: 'BILLING/UPDATE_BILLING_ACCOUNT_BANK_ACCOUNT',
  payload: http({
    method: 'PUT',
    url: `api/v1/billingAccounts/${ban}/bankAccount`,
    data: { paymentMethodId },
  }),
})

// After finishing payment method setup on Stripe we have to
// update expire date, country, brand and last 4 digits in CRM
export const updateCreditCard = ({ ban, paymentMethodId }) => ({
  type: 'BILLING/UPDATE_BILLING_ACCOUNT_CREDIT_CARD',
  payload: http({
    method: 'PUT',
    url: `api/v1/billingAccounts/${ban}/creditCard`,
    data: { paymentMethodId },
  }),
})



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/Billing.actions.js